export default [
    // packages ordered by priority
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFTTNL",
    "PFPTTF",
    "PFPTTNL",
    "PFTTF",
    "PFP",
    "PF",
    "HS",
];
